import React from "react";
import { useLocation, useNavigate, Link as RouterLink } from "react-router-dom";

// Lee el slug de agencia directo de la URL (/a/:slug/...) usando useLocation,
// que funciona en cualquier punto dentro de <BrowserRouter> — no depende de
// estar dentro de un <Route> ya emparejado, a diferencia de useParams().
function extractSlug(pathname) {
  const m = pathname.match(/^\/a\/([^/]+)/);
  return m ? m[1] : null;
}

export function useAgencySlug() {
  const location = useLocation();
  return extractSlug(location.pathname);
}

// Antepone /a/:slug a una ruta relativa si estamos dentro de una agencia.
export function useAgencyPath() {
  const slug = useAgencySlug();
  return (path) => (slug ? `/a/${slug}${path}` : path);
}

// Reemplazo directo de useNavigate() que respeta el prefijo de agencia.
export function useAgencyNavigate() {
  const navigate = useNavigate();
  const toPath = useAgencyPath();
  return (path, opts) => navigate(toPath(path), opts);
}

// Reemplazo directo de <Link> que respeta el prefijo de agencia.
export function AgencyLink({ to, ...props }) {
  const toPath = useAgencyPath();
  return <RouterLink to={toPath(to)} {...props} />;
}
